import React, { useState } from "react";
import LOGO from "../assets/logo.56e3480b593ac0c2f57f8090df2b8b08.svg";
import THEME from "../assets/Combined-Shape.eb2adc05c80635dddf06c13ffb92a7b2.svg";

function Navbar() {
  const [open, setOpen] = useState(false);
  const [linksOpen, setLinksOpen] = useState(false);
  let toggleHamburger = (event) => {
    setOpen(!open);
  };
  let toggleLinks = (event) => {
    console.log("clicked");
    setLinksOpen(!linksOpen);
  };
  return (
    <div className="custom-navbar-container ">
      <div className="custom-link-container">
        <ul className="custom-link-list">
          <div className="custom-logo-container">
            <img className="custom-logo" src={LOGO} alt="" />
          </div>
          <div
            className={
              linksOpen
                ? "custom-link-set custom-linkset-show"
                : "custom-link-set custom-linkset-hide"
            }
            // id="custom-link-set-first"
          >
            <li className="custom-first-link">
              <a style={{ color: "black !important" }} href="">
                About
              </a>
            </li>
            <div className="custom-border-bottom"></div>
            <li>
              <a href="">Services</a>
            </li>
            <div className="custom-border-bottom"></div>
            <li>
              <a href="">technologies</a>
            </li>
            <div className="custom-border-bottom"></div>
            <li>
              <a href="">Industries</a>
            </li>
            <div className="custom-border-bottom"></div>
            <li>
              <a href="">Projects</a>
            </li>
            <div className="custom-border-bottom"></div>
            <li className="custom-lets-talk">
              <a href="#">Let's Talk</a>
            </li>
            <li className="custom-change-theme">
              <img style={{ cursor: "pointer" }} src={THEME} alt="" />
            </li>
          </div>
          <div
            className={open ? "custom-menu-btn open" : "custom-menu-btn"}
            onClick={(event) => {
              toggleHamburger(event);
              toggleLinks(event);
            }}
          >
            <div
              class="custom-menu-btn-burger"
              style={{ backgroundColor: "white" }}
            ></div>
          </div>
        </ul>
      </div>
    </div>
  );
}

export default Navbar;
